import { FC } from 'react';
// mui components
import { Avatar, Grid } from '@mui/material';
// components
import DefaultAvatar from 'components/default-avatar';
// api
// helpers
import { getImageBySize } from 'utils/helpers';
// styles
import { IPost } from '_interfaces/post.interface';
import { postItemStyles as styles } from '../../styles/styles';

interface IProps {
  post: IPost;
  size?: number;
}

const PostAvatar: FC<IProps> = ({ post, size = 40 }) => {
  const nameSplit = post.createdBy?.displayName?.split(' ');
  const initials = `${nameSplit?.[0]?.[0]}${nameSplit?.[1]?.[0]}`;

  return (
    <Grid sx={styles.avatarContainer(size)}>
      {post.createdBy?.avatarUrl && post.createdBy?.avatarUrl.trim() !== '' ? (
        <>
          <Avatar
            alt="avatar"
            sx={styles.avatar}
            src={getImageBySize(post.createdBy?.avatarUrl, size, size)}
            variant="square"
          />
        </>
      ) : (
        <>
          {/* {!post.isViewed ? <Grid sx={styles.greenDot}></Grid> : null} */}
          <DefaultAvatar
            initials={initials}
            alt="avatar"
            variant="square"
            sx={{
              borderRadius: '4px',
              width: `${size}px`,
              height: `${size}px`,
              fontSize: `${size * 0.5}px`,
            }}
          />
        </>
      )}
    </Grid>
  );
};

export default PostAvatar;
